import React from "react";
import PropTypes from "prop-types";
import "./ProductLink.scss";
import PageLink from "../share/PageLink/PageLink";

const ArrowRight = () => (
  <svg className="ProductLink__arrowIcon" viewBox="0 0 28 28" fill="none" aria-hidden="true">
    <path d="M5 14h18M16 7l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ProductLink = ({
  label,
  text,
  path,
  className,
  onMouseEnter,
  onMouseLeave,
}) => {
  return path ? (
    <PageLink
      className={`ProductLink${className ? " " + className : ""}`}
      to={`/product/${path}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="ProductLink__inner">
        <div className="ProductLink__text">
          <span className="ProductLink__label">{label}</span>
          <span className="ProductLink__products">{text}</span>
        </div>
        <ArrowRight />
      </div>
    </PageLink>
  ) : null;
};

ProductLink.propTypes = {
  label: PropTypes.string,
  text: PropTypes.string,
  path: PropTypes.string,
};

export default ProductLink;
